var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell weui-cell_switch"},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{staticClass:"weui-switch",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.updateValue}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314401da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/weui/switch/Index.vue
// module id = null
// module chunks = 